<template>
  <div class="svg-icon center-block" :style="style">
    <component :is="dynamicIcon"/>
  </div>
</template>

<script>
export default {
  name: 'svg-icon',
  props: {
    icon: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#777'
    }
  },
  computed: {
    dynamicIcon () {
      return () => import(
        /* webpackChunkName: "icons" */
        /* webpackMode: "lazy-once" */
        '../assets/flaticon/' + this.icon + '.isvg'
      )
    },

    style () {
      return `fill: ${this.color}`
    }
  }
}
</script>

<style lang="less">
.svg-icon {
    height: 100%;

    svg {
        max-width: 100%;
        height: auto;
        display: block;
    }
}
</style>
